import React, { useState, useCallback, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import { countLikes } from "services/apiService";
import { useNavigate } from "react-router-dom";
import dialogBgImage from "assets/images/dialogBgImage.png";
import { useMediaQuery } from "react-responsive";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton, InputAdornment } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import SpinLoader from "components/SpinLoader";

function LikesDialog({ openStatus, onClose, postId }) {
  let navigate = useNavigate();
  const [likesData, setLikesData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [isFetchMore, setIsFetchMore] = useState(false);
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  useEffect(() => {
    fetchLikesCount();
  }, []);

  const fetchLikesCount = async () => {
    const likeDataRes = await countLikes(postId, pageNumber);
    // console.log("likeDataRes", likeDataRes);
    setLikesData(likeDataRes);
    if (likeDataRes.length > 1) {
      setIsFetchMore(true);
    }
    setPageNumber((prev) => prev + 1);
  };

  const handleNavigate = (value) => {
    navigate(`/profile/?username=${value}`);
  };

  const fetchMoreData = async () => {
    const likeDataRes = await countLikes(postId, pageNumber);
    if (likeDataRes.length < 1) {
      setIsFetchMore(false);
      return;
    }

    setIsFetchMore(true);
    setLikesData(likesData.concat(likeDataRes));
    setPageNumber((prev) => prev + 1);
  };

  return (
    <Dialog
      sx={{}}
      open={openStatus}
      maxWidth="sm"
      fullWidth
      fullScreen={isTabletOrMobile && true}
      onClose={onClose}
    >
      <MDBox
        id="scrollableBox"
        sx={{
          overflow: "auto",
          height: isTabletOrMobile && "1000px",
          border: isDesktopOrLaptop && "1px solid #F2CB2E",
          borderRadius: isDesktopOrLaptop && "8px",
          backgroundColor: "#1a1a1a",
          // backgroundImage: `url(${dialogBgImage})`,
          // backgroundRepeat: "no-repeat",
          // backgroundSize: "cover",
          // objectFit: "cover",
          // backgroundPosition: isTabletOrMobile && "bottom",
        }}
      >
        <DialogTitle sx={{ textAlign: "center" }}>
          <MDBox
            sx={{
              display: isTabletOrMobile && "flex",
              justifyContent: isTabletOrMobile && "space-between",
            }}
          >
            {isTabletOrMobile && (
              <IconButton>
                <IconButton onClick={onClose} color="white" fontSize="30px">
                  <ArrowBackIcon />
                </IconButton>
              </IconButton>
            )}

            <MDBox>
              <MDTypography
                fontWeight="bold"
                color="singh"
                sx={{
                  fontSize: isTabletOrMobile ? "15px" : "30px",
                  marginRight: isTabletOrMobile && "120px",
                  marginTop: isTabletOrMobile && "15px",
                }}
              >
                Like
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogTitle>
        <DialogContent>
          <InfiniteScroll
            scrollableTarget="scrollableBox"
            dataLength={likesData.length}
            next={fetchMoreData}
            hasMore={isFetchMore}
            loader={
              <MDBox sx={{ textAlign: "center" }}>
                <SpinLoader />
              </MDBox>
            }
          >
            {likesData.length > 0 ? (
              likesData.map((item, idx) => (
                <MDBox
                  style={{
                    marginBottom: "20px",
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                  }}
                  onClick={() => handleNavigate(item.username)}
                >
                  <MDAvatar
                    src={item.pic}
                    imgProps={{ style: { height: "100%", width: "100%" } }}
                  />
                  <MDTypography>{item.username}</MDTypography>
                </MDBox>
              ))
            ) : (
              <MDBox sx={{ textAlign: "center", marginTop: "3rem" }}>
                <MDTypography color="text">No likes yet!</MDTypography>
              </MDBox>
            )}
          </InfiniteScroll>
        </DialogContent>
      </MDBox>
    </Dialog>
  );
}

export default LikesDialog;
